export function isModalEntityPrivacyEnabled(field) {
	return field?.privacy === true || field?.privacy === 'true';
}

export function formatModalEntityDisplayValue(raw) {
	if (raw === null || raw === undefined || raw === '') {
		return '';
	}

	if (typeof raw === 'object') {
		return raw.name || raw.label || '';
	}

	return String(raw);
}
